// Mock data for Trattoria Pizzeria Da Daniele

export const restaurantInfo = {
  name: "Trattoria Da Daniele",
  tagline: "Autentica cucina italiana dal 2003",
  address: "Goldgasse 15, 4500 Solothurn",
  phone: "+41 32 622 22 22",
  email: "mail@trattoria-daniele.ch",
  founded: 2003,
  description: "La Trattoria Pizzeria Da Daniele si trova nel cuore della città di Solothurn. Il ristorante italiano vi accoglie su due piani e su una grande terrazza nel Vigierhof."
};

export const heroContent = {
  title: "Benvenuti alla",
  subtitle: "Trattoria Da Daniele",
  description: "Un viaggio culinario attraverso i sapori autentici dell'Italia, nel cuore di Solothurn dal 2003.",
  cta: "Scopri il Menu",
  secondaryCta: "Prenota un Tavolo"
};

export const aboutContent = {
  title: "La Nostra Storia",
  subtitle: "Tradizione e Passione",
  paragraphs: [
    "Nel 2003, il giovane imprenditore Daniele ha deciso di mettersi in proprio e di offrire alla città di Solothurn una cucina italiana variegata e autentica.",
    "La Trattoria Pizzeria Da Daniele è da molti anni uno dei ristoranti più amati di Solothurn. Dalla selezione \"à la carte\" ai gustosi piatti di carne e pesce fino agli eccellenti menu del giorno, offriamo una deliziosa scelta per ogni palato.",
    "L'ospitalità e un'atmosfera rilassata e informale rendono questo ristorante un'esperienza speciale!"
  ],
  image: "/images/restaurant/trattoria_da_daniele_001.jpg"
};

export const menuCategories = [
  {
    id: 1,
    name: "Antipasti",
    nameDE: "Vorspeisen",
    nameFR: "Entrées",
    nameEN: "Starters",
    icon: "Salad",
    items: [
      { name: "Antipasto all'Italiana", descIT: "Salame, prosciutto di Parma, melanzane", descDE: "Salami, Parmaschinken, Aubergine", descFR: "Salami, jambon de Parme, aubergine", descEN: "Salami, Parma ham, aubergine", price: "19.00" },
      { name: "Caprese Bufala Pachino", descIT: "Mozzarella di bufala con pomodori", descDE: "Büffelmozzarella mit Tomaten", descFR: "Mozzarella di bufala avec tomates", descEN: "Buffalo mozzarella with tomatoes", price: "15.50" },
      { name: "Caprese Burrata Pomodorini", descIT: "Burrata con pomodorini", descDE: "Burrata mit Cherry-Tomaten", descFR: "Burrata avec tomates cerises", descEN: "Burrata with cherry tomatoes", price: "14.50" },
      { name: "Bresaola, Rucola e Parmigiano", descIT: "Bresaola con rucola e parmigiano", descDE: "Bresaola mit Rucola und Parmesan", descFR: "Bresaola avec roquette et parmesan", descEN: "Bresaola with rocket and parmesan", price: "21.00" },
      { name: "Bruschetta al Pomodoro Fresco", descIT: "Pane tostato con pomodori, basilico, cipolla e aglio", descDE: "Knusprig geröstetes Brot mit Tomaten, Basilikum, Zwiebeln und Knoblauch", descFR: "Pain grillé avec tomates, basilic, oignons et ail", descEN: "Toasted bread with tomatoes, basil, onion and garlic", price: "12.00" },
      { name: "Fettunta Chiantigiana", descIT: "Pane tostato con olio d'oliva e aglio", descDE: "Knusprig geröstetes Brot mit Olivenöl und Knoblauch", descFR: "Pain grillé à l'huile d'olive et ail", descEN: "Toasted bread with olive oil and garlic", price: "8.00" },
      { name: "Insalata Verde", descIT: "Insalata verde", descDE: "Grüner Salat", descFR: "Salade verte", descEN: "Green salad", price: "8.00" },
      { name: "Insalata Mista", descIT: "Insalata mista", descDE: "Gemischter Salat", descFR: "Salade mixte", descEN: "Mixed salad", price: "9.00" },
      { name: "Insalata Caprese", descIT: "Insalata di pomodori con mozzarella", descDE: "Tomatensalat mit Mozzarella", descFR: "Salade de tomates avec mozzarella", descEN: "Tomato salad with mozzarella", price: "12.50" },
      { name: "Pomodori con Cipolle", descIT: "Insalata di pomodori con cipolle", descDE: "Tomatensalat mit Zwiebeln", descFR: "Salade de tomates aux oignons", descEN: "Tomato salad with onions", price: "9.50" },
      { name: "Rucola e Parmigiano", descIT: "Rucola con parmigiano", descDE: "Rucola mit Parmesan", descFR: "Roquette au parmesan", descEN: "Rocket with parmesan", price: "9.50" },
      { name: "Grosser Salatteller mit Ei", descIT: "Grande insalata con uovo", descDE: "Grosser Salatteller mit Ei", descFR: "Grande salade avec œuf", descEN: "Large salad platter with egg", price: "18.00" }
    ]
  },
  {
    id: 2,
    name: "Pasta",
    nameDE: "Pasta",
    nameFR: "Pâtes",
    nameEN: "Pasta",
    icon: "UtensilsCrossed",
    items: [
      { name: "Tagliatelle al Pesto", descIT: "Con pesto al basilico", descDE: "Mit Basilikum-Pesto", descFR: "Avec pesto au basilic", descEN: "With basil pesto", price: "21.00" },
      { name: "Tagliatelle alla Bolognese", descIT: "Con ragù di carne", descDE: "Mit Fleischsauce", descFR: "Avec sauce à la viande", descEN: "With meat ragù", price: "21.00" },
      { name: "Tagliatelle alla Carbonara", descIT: "Con uovo, pancetta e parmigiano", descDE: "Mit Ei, Speck und Parmesan", descFR: "Avec œuf, lardons et parmesan", descEN: "With egg, bacon and parmesan", price: "21.00" },
      { name: "Tagliatelle al Pomodoro", descIT: "Con salsa di pomodoro", descDE: "Mit Tomatensauce", descFR: "Avec sauce tomate", descEN: "With tomato sauce", price: "18.00" },
      { name: "Tagliatelle ai Funghi Porcini", descIT: "Con funghi porcini", descDE: "Mit Steinpilzen", descFR: "Avec cèpes", descEN: "With porcini mushrooms", price: "24.00" },
      { name: "Tagliatelle Crema di Tartufo", descIT: "Con crema di tartufo", descDE: "Mit Trüffelcreme", descFR: "Avec crème de truffe", descEN: "With truffle cream", price: "26.00" },
      { name: "Chitarra ai Frutti di Mare", descIT: "Con frutti di mare", descDE: "Mit Meeresfrüchten", descFR: "Avec fruits de mer", descEN: "With seafood", price: "24.00" },
      { name: "Chitarra ai Gamberoni", descIT: "Con gamberoni", descDE: "Mit Riesengarnelen", descFR: "Avec gambas", descEN: "With king prawns", price: "24.00" },
      { name: "Chitarra alle Vongole", descIT: "Con vongole", descDE: "Mit Venusmuscheln", descFR: "Avec palourdes", descEN: "With clams", price: "24.00" },
      { name: "Chitarra alle Cozze", descIT: "Con cozze", descDE: "Mit Miesmuscheln", descFR: "Avec moules", descEN: "With mussels", price: "21.00" },
      { name: "Strozza Preti all'Arrabbiata", descIT: "Con salsa di pomodoro piccante", descDE: "Mit scharfer Tomatensauce", descFR: "Avec sauce tomate piquante", descEN: "With spicy tomato sauce", price: "18.00" },
      { name: "Strozza Preti al Salmone", descIT: "Con salmone", descDE: "Mit Lachs", descFR: "Avec saumon", descEN: "With salmon", price: "21.00" },
      { name: "Strozzapreti Salsiccia Porcini", descIT: "Con salsiccia e porcini", descDE: "Mit Wurst und Steinpilzen", descFR: "Avec saucisse et cèpes", descEN: "With sausage and porcini mushrooms", price: "25.00" },
      { name: "Strozzapreti Pesto e Burrata", descIT: "Con pesto e burrata", descDE: "Mit Pesto und Burrata", descFR: "Avec pesto et burrata", descEN: "With pesto and burrata", price: "24.00" },
      { name: "Strozzapreti Crema di Tartufo Burrata", descIT: "Con crema di tartufo e burrata", descDE: "Mit Trüffelcreme und Burrata", descFR: "Avec crème de truffe et burrata", descEN: "With truffle cream and burrata", price: "26.00" },
      { name: "Lasagne al Forno", descIT: "Lasagne fatte in casa", descDE: "Hausgemachte Lasagne", descFR: "Lasagnes maison", descEN: "Homemade lasagne", price: "21.00" },
      { name: "Cannelloni alla Romana", descIT: "Con ripieno di carne", descDE: "Mit Fleischfüllung", descFR: "Avec farce à la viande", descEN: "With meat filling", price: "21.00" },
      { name: "Cannelloni Ricotta e Spinaci", descIT: "Con ricotta e spinaci", descDE: "Mit Ricotta und Spinat", descFR: "Avec ricotta et épinards", descEN: "With ricotta and spinach", price: "21.00" },
      { name: "Gnocchi al Gorgonzola", descIT: "Con salsa al gorgonzola", descDE: "Mit Gorgonzola-Sauce", descFR: "Avec sauce gorgonzola", descEN: "With gorgonzola sauce", price: "20.50" },
      { name: "Gnocchi al Pomodoro", descIT: "Con salsa di pomodoro", descDE: "Mit Tomatensauce", descFR: "Avec sauce tomate", descEN: "With tomato sauce", price: "19.00" },
      { name: "Gnocchi alla Bolognese", descIT: "Con ragù di carne", descDE: "Mit Fleischsauce", descFR: "Avec sauce à la viande", descEN: "With meat ragù", price: "21.00" },
      { name: "Gnocchi al Pesto Genovese", descIT: "Con pesto genovese", descDE: "Mit Genueser Pesto", descFR: "Avec pesto génois", descEN: "With Genovese pesto", price: "21.50" }
    ]
  },
  {
    id: 3,
    name: "Ravioli",
    nameDE: "Ravioli",
    nameFR: "Raviolis",
    nameEN: "Ravioli",
    icon: "ChefHat",
    items: [
      { name: "Ravioli Ricotta e Spinaci", descIT: "Ravioli con ricotta e spinaci in salsa rosa", descDE: "Ravioli mit Quark- und Spinat-Füllung an Tomaten- und Rahmsauce", descFR: "Raviolis ricotta et épinards en sauce rose", descEN: "Ravioli with ricotta and spinach in rosé sauce", price: "24.00" },
      { name: "Agnolotti di Vitello allo Zafferano", descIT: "Ripieni di vitello con burro, salvia e zafferano", descDE: "Gefüllt mit Kalbfleisch an Butter-Salbei-Safransauce", descFR: "Farcis au veau avec beurre, sauge et safran", descEN: "Veal-filled with butter, sage and saffron sauce", price: "26.00" },
      { name: "Ravioli alla Piemontese", descIT: "Con ripieno di carne, burro e salvia", descDE: "Mit Fleisch-Füllung an Butter und Salbei", descFR: "Avec farce à la viande, beurre et sauge", descEN: "With meat filling, butter and sage", price: "25.00" },
      { name: "Ravioli al Tartufo", descIT: "Ripieni di tartufo", descDE: "Gefüllt mit Trüffel", descFR: "Farcis à la truffe", descEN: "Truffle-filled", price: "26.00" },
      { name: "Tortelloni alla Panna", descIT: "Con ripieno di carne in salsa di panna", descDE: "Mit Fleisch-Füllung an Rahmsauce", descFR: "Avec farce à la viande en sauce crème", descEN: "With meat filling in cream sauce", price: "23.00" },
      { name: "Tortelloni ai Porcini alla Toscana", descIT: "Con ripieno di porcini alla toscana", descDE: "Mit Steinpilz-Füllung nach Toskanischer Art", descFR: "Avec farce aux cèpes à la toscane", descEN: "With porcini filling Tuscan style", price: "26.00" },
      { name: "Panciotti Melanzane e Scamorza", descIT: "Con melanzane e scamorza al pesto calabrese", descDE: "Mit Auberginen- und Scamorza-Füllung an Basilikum-Sauce", descFR: "Avec aubergines et scamorza au pesto calabrais", descEN: "With aubergine and scamorza in Calabrian pesto", price: "26.00" },
      { name: "Fiochetti al Gorgonzola", descIT: "Con ripieno di gorgonzola alla siciliana", descDE: "Mit Gorgonzola-Füllung an Auberginen-Sauce", descFR: "Avec farce au gorgonzola à la sicilienne", descEN: "With gorgonzola filling Sicilian style", price: "24.00" }
    ]
  },
  {
    id: 4,
    name: "Risotto",
    nameDE: "Risotto",
    nameFR: "Risotto",
    nameEN: "Risotto",
    icon: "Wheat",
    items: [
      { name: "Risotto ai Frutti di Mare", descIT: "Con frutti di mare", descDE: "Mit Meeresfrüchten", descFR: "Avec fruits de mer", descEN: "With seafood", price: "24.00" },
      { name: "Risotto ai Funghi Porcini", descIT: "Con funghi porcini", descDE: "Mit Steinpilzen", descFR: "Avec cèpes", descEN: "With porcini mushrooms", price: "26.00" },
      { name: "Risotto alla Milanese", descIT: "Risotto allo zafferano", descDE: "Safran-Risotto", descFR: "Risotto au safran", descEN: "Saffron risotto", price: "28.00" },
      { name: "Risotto Crema di Tartufo e Burrata", descIT: "Con crema di tartufo e burrata", descDE: "Mit Trüffelsauce und Burrata", descFR: "Avec crème de truffe et burrata", descEN: "With truffle cream and burrata", price: "26.00" }
    ]
  },
  {
    id: 5,
    name: "Pizza",
    nameDE: "Pizza",
    nameFR: "Pizza",
    nameEN: "Pizza",
    icon: "Pizza",
    items: [
      { name: "Margherita", descIT: "Pomodoro, mozzarella, origano", descDE: "Tomaten, Mozzarella, Oregano", descFR: "Tomates, mozzarella, origan", descEN: "Tomato, mozzarella, oregano", price: "16.50" },
      { name: "Margherita Bufala", descIT: "Con mozzarella di bufala", descDE: "Mit Büffelmozzarella", descFR: "Avec mozzarella di bufala", descEN: "With buffalo mozzarella", price: "19.50" },
      { name: "Napoletana", descIT: "Pomodoro, mozzarella, acciughe, capperi, olive", descDE: "Tomaten, Mozzarella, Sardellen, Kapern, Oliven", descFR: "Tomates, mozzarella, anchois, câpres, olives", descEN: "Tomato, mozzarella, anchovies, capers, olives", price: "18.00" },
      { name: "Quattro Stagioni", descIT: "Prosciutto, carciofi, olive, funghi", descDE: "Schinken, Artischocken, Oliven, Champignons", descFR: "Jambon, artichauts, olives, champignons", descEN: "Ham, artichokes, olives, mushrooms", price: "20.50" },
      { name: "Quattro Formaggi", descIT: "Quattro tipi di formaggio", descDE: "Vier Käsesorten", descFR: "Quatre fromages", descEN: "Four types of cheese", price: "19.00" },
      { name: "Funghi", descIT: "Funghi, origano", descDE: "Champignons, Oregano", descFR: "Champignons, origan", descEN: "Mushrooms, oregano", price: "17.50" },
      { name: "Funghi e Prosciutto", descIT: "Funghi, prosciutto", descDE: "Champignons, Schinken", descFR: "Champignons, jambon", descEN: "Mushrooms, ham", price: "19.00" },
      { name: "Funghi Porcini", descIT: "Con funghi porcini", descDE: "Mit Steinpilzen", descFR: "Avec cèpes", descEN: "With porcini mushrooms", price: "24.00" },
      { name: "San Daniele", descIT: "Prosciutto crudo, olive", descDE: "Rohschinken, Oliven", descFR: "Jambon cru, olives", descEN: "Raw ham, olives", price: "24.00" },
      { name: "Prosciutto", descIT: "Prosciutto, origano", descDE: "Schinken, Oregano", descFR: "Jambon, origan", descEN: "Ham, oregano", price: "18.50" },
      { name: "Salami", descIT: "Salame, origano", descDE: "Salami, Oregano", descFR: "Salami, origan", descEN: "Salami, oregano", price: "18.50" },
      { name: "Calabrese", descIT: "Salsiccia piccante, aglio, olive", descDE: "Pikante italienische Wurst, Knoblauch, Oliven", descFR: "Saucisse piquante, ail, olives", descEN: "Spicy sausage, garlic, olives", price: "19.50" },
      { name: "Diavola", descIT: "Peperoncino, salame piccante, cipolle", descDE: "Peperoncino, scharfe Salami, Zwiebeln", descFR: "Piment, salami piquant, oignons", descEN: "Chilli, spicy salami, onions", price: "19.50" },
      { name: "Hawaii", descIT: "Prosciutto, ananas, origano", descDE: "Schinken, Ananas, Oregano", descFR: "Jambon, ananas, origan", descEN: "Ham, pineapple, oregano", price: "18.50" },
      { name: "Siciliana", descIT: "Melanzane, aglio, olive", descDE: "Auberginen, Knoblauch, Oliven", descFR: "Aubergines, ail, olives", descEN: "Aubergines, garlic, olives", price: "18.00" },
      { name: "Tonno", descIT: "Tonno, cipolle, olive, capperi", descDE: "Thunfisch, Zwiebeln, Oliven, Kapern", descFR: "Thon, oignons, olives, câpres", descEN: "Tuna, onions, olives, capers", price: "18.50" },
      { name: "Vegetariana", descIT: "Verdure miste", descDE: "Verschiedene Gemüse", descFR: "Légumes variés", descEN: "Mixed vegetables", price: "19.00" },
      { name: "Calzone", descIT: "Carciofi, peperoni, olive, prosciutto, salame, funghi", descDE: "Artischocken, Peperoni, Oliven, Schinken, Salami, Champignons", descFR: "Artichauts, poivrons, olives, jambon, salami, champignons", descEN: "Artichokes, peppers, olives, ham, salami, mushrooms", price: "21.00" },
      { name: "Cappricciosa", descIT: "Peperoni, carciofi, prosciutto, acciughe, olive, funghi", descDE: "Peperoni, Artischocken, Schinken, Sardellen, Oliven, Champignons", descFR: "Poivrons, artichauts, jambon, anchois, olives, champignons", descEN: "Peppers, artichokes, ham, anchovies, olives, mushrooms", price: "20.50" },
      { name: "Rucola e Prosciutto Crudo", descIT: "Prosciutto crudo, rucola", descDE: "Rohschinken, Rucola", descFR: "Jambon cru, roquette", descEN: "Raw ham, rocket", price: "24.00" },
      { name: "Bufala Crudo", descIT: "Mozzarella di bufala, prosciutto crudo", descDE: "Büffelmozzarella, Rohschinken", descFR: "Mozzarella di bufala, jambon cru", descEN: "Buffalo mozzarella, raw ham", price: "25.00" },
      { name: "Rucola Bufala e Crudo", descIT: "Rucola, mozzarella di bufala, prosciutto crudo", descDE: "Rucola, Büffelmozzarella, Rohschinken", descFR: "Roquette, mozzarella di bufala, jambon cru", descEN: "Rocket, buffalo mozzarella, raw ham", price: "25.00" },
      { name: "Burrata e Nduja", descIT: "Con burrata e nduja piccante", descDE: "Mit Burrata und scharfer Streichwurst", descFR: "Avec burrata et nduja piquante", descEN: "With burrata and spicy nduja", price: "25.00" },
      { name: "Burrata e Pesto", descIT: "Con burrata e pesto", descDE: "Mit Burrata und Pesto", descFR: "Avec burrata et pesto", descEN: "With burrata and pesto", price: "23.00" },
      { name: "Crema di Tartufo Porcini Burrata", descIT: "Crema di tartufo, porcini, burrata", descDE: "Trüffelcreme, Steinpilze, Burrata", descFR: "Crème de truffe, cèpes, burrata", descEN: "Truffle cream, porcini, burrata", price: "26.00" },
      { name: "Salsiccia Porcini", descIT: "Salsiccia e funghi porcini", descDE: "Salsiccia und Steinpilze", descFR: "Saucisse et cèpes", descEN: "Sausage and porcini mushrooms", price: "24.00" },
      { name: "Campioni", descIT: "Roast beef, parmigiano, rucola", descDE: "Roastbeef, Parmesan, Rucola", descFR: "Roast beef, parmesan, roquette", descEN: "Roast beef, parmesan, rocket", price: "26.00" }
    ]
  },
  {
    id: 6,
    name: "Carne",
    nameDE: "Fleisch",
    nameFR: "Viandes",
    nameEN: "Meat",
    icon: "Beef",
    items: [
      { name: "Piccata alla Milanese", descIT: "Vitello alla milanese", descDE: "Kalbfleisch Mailänder Art", descFR: "Veau à la milanaise", descEN: "Veal Milanese style", price: "35.00" },
      { name: "Saltimbocca alla Romana", descIT: "Vitello con prosciutto crudo e salvia", descDE: "Kalbfleisch mit Rohschinken und Salbei", descFR: "Veau avec jambon cru et sauge", descEN: "Veal with raw ham and sage", price: "36.00" },
      { name: "Scaloppina al Limone", descIT: "Scaloppina di vitello al limone", descDE: "Kalbsschnitzel mit Zitronensauce", descFR: "Escalope de veau au citron", descEN: "Veal escalope with lemon", price: "33.00" },
      { name: "Scaloppine ai Funghi", descIT: "Scaloppine di vitello con funghi", descDE: "Kalbsschnitzel mit Pilzen", descFR: "Escalopes de veau aux champignons", descEN: "Veal escalopes with mushrooms", price: "33.00" },
      { name: "Filetto al Pepe Verde", descIT: "Filetto di manzo al pepe verde", descDE: "Rindsfilet an grüner Pfeffersauce", descFR: "Filet de bœuf au poivre vert", descEN: "Beef fillet in green peppercorn sauce", price: "41.00" },
      { name: "Tagliata di Manzo", descIT: "Entrecôte tagliata", descDE: "Geschnittenes Entrecôte", descFR: "Entrecôte tranchée", descEN: "Sliced entrecôte", price: "39.00" },
      { name: "Entrecôte Café de Paris", descIT: "Entrecôte con burro Café de Paris", descDE: "Entrecôte mit Café de Paris Butter", descFR: "Entrecôte au beurre Café de Paris", descEN: "Entrecôte with Café de Paris butter", price: "39.00" }
    ]
  },
  {
    id: 7,
    name: "Zuppe",
    nameDE: "Suppen",
    nameFR: "Soupes",
    nameEN: "Soups",
    icon: "Soup",
    items: [
      { name: "Minestrone", descIT: "Zuppa di verdure", descDE: "Gemüsesuppe", descFR: "Soupe de légumes", descEN: "Vegetable soup", price: "9.00" },
      { name: "Tomatensuppe", descIT: "Zuppa di pomodoro", descDE: "Tomatensuppe", descFR: "Soupe de tomates", descEN: "Tomato soup", price: "9.00" },
      { name: "Tortelloni in Brodo", descIT: "Tortelloni in brodo", descDE: "Tortelloni in Brühe", descFR: "Tortellonis en bouillon", descEN: "Tortelloni in broth", price: "9.00" }
    ]
  },
  {
    id: 8,
    name: "Per Bambini",
    nameDE: "Für Kinder",
    nameFR: "Pour Enfants",
    nameEN: "For Kids",
    icon: "Baby",
    items: [
      { name: "Spaghetti Napoli", descIT: "Porzione bambini con salsa di pomodoro", descDE: "Kinderportion mit Tomatensauce", descFR: "Portion enfant avec sauce tomate", descEN: "Child portion with tomato sauce", price: "9.50" },
      { name: "Pizza Topolino", descIT: "Pizza bambini con pomodoro e prosciutto", descDE: "Kinderpizza mit Tomaten und Schinken", descFR: "Pizza enfant avec tomates et jambon", descEN: "Child pizza with tomato and ham", price: "11.00" }
    ]
  }
];

export const features = [
  {
    icon: "ChefHat",
    title: "Cucina Autentica",
    description: "Ricette tradizionali italiane preparate con ingredienti freschi e di qualità."
  },
  {
    icon: "Wine",
    title: "Vini Selezionati",
    description: "Una ricca carta dei vini con le migliori etichette italiane."
  },
  {
    icon: "Users",
    title: "Atmosfera Familiare",
    description: "Un ambiente accogliente dove sentirsi come a casa."
  },
  {
    icon: "Sparkles",
    title: "Terrazza Panoramica",
    description: "Grande terrazza nel Vigierhof per pranzi e cene all'aperto."
  }
];

export const galleryImages = [
  {
    src: "/images/restaurant/trattoria_da_daniele_solothurn.jpg",
    alt: ""
  },
  {
    src: "/images/restaurant/trattoria_da_daniele_002.jpg",
    alt: ""
  },
  {
    src: "/images/restaurant/trattoria_da_daniele_003.jpg",
    alt: ""
  },
  {
    src: "/images/restaurant/IMG_0846.jpg",
    alt: ""
  },
  {
    src: "/images/restaurant/IMG_0845.jpg",
    alt: ""
  },
  {
    src: "/images/restaurant/IMG_0844.jpg",
    alt: ""
  },
  {
    src: "/images/restaurant/trattoria_da_daniele_004.jpg",
    alt: ""
  },
  {
    src: "/images/restaurant/trattoria_da_daniele_005.jpg",
    alt: ""
  }
];

export const openingHours = [
  { day: "Lunedì", hours: "Chiuso" },
  { day: "Martedì", hours: "11:30 - 14:00, 18:00 - 22:00" },
  { day: "Mercoledì", hours: "11:30 - 14:00, 18:00 - 22:00" },
  { day: "Giovedì", hours: "11:30 - 14:00, 18:00 - 22:00" },
  { day: "Venerdì", hours: "11:30 - 14:00, 18:00 - 23:00" },
  { day: "Sabato", hours: "18:00 - 23:00" },
  { day: "Domenica", hours: "11:30 - 14:00, 18:00 - 22:00" }
];

export const testimonials = [
  {
    name: "Reto S.",
    text: "Bestes Restaurant in Solothurn Ever! Seit Jahren bin ich Stammkunde und Daniele ist ein toller Gastgeber. Ti amo per sempre❤️",
    rating: 5
  },
  {
    name: "Giorgio R.",
    text: "Ottimo, tutto buonissimo, Personale simpaticissimo! Complimenti",
    rating: 5
  },
  {
    name: "Peter C.",
    text: "One of the best pizzas I have ever had! Excellent!",
    rating: 5
  },
  {
    name: "Maria G.",
    text: "Mangiare buonissimo. Personale gentilissimo. Siamo rimasti molto soddisfatti",
    rating: 5
  },
  {
    name: "Amanda D.",
    text: "Absolut Top! Ich bestelle immer gerne das Risotto, aber alles andere ist auch super. Sehr freundliche Leute, super Küche.",
    rating: 5
  },
  {
    name: "Lili S.",
    text: "Wir wurden wie immer sehr freundlich und herzlich empfangen und auch das Essen war sehr gut. Tolles, aufgestelltes Team, angenehme Atmosphäre.",
    rating: 5
  },
  {
    name: "Gianluca R.",
    text: "Top pizza! Und der Limoncello nach der Rechnung war eine sympathische Überraschung. Schauen sehr gerne wieder vorbei! 👌🏻",
    rating: 5
  },
  {
    name: "Ardit F.",
    text: "Das Essen war Top, Komplimente von mir. Tiramisu kann man nicht übertreffen, sehr lecker.",
    rating: 5
  }
];

// Menu Attuale - Piatti del momento
export const menuAttuale = {
  categories: [
    {
      name: "Spezialität",
      nameIT: "Specialità",
      nameDE: "Spezialität",
      nameFR: "Spécialités",
      nameEN: "Specialities",
      items: [
        { name: "Nüsslisalat Mimosa mit Ei", descIT: "Insalata di valeriana con uovo mimosa", descDE: "Nüsslisalat mit Mimosa-Ei", descFR: "Salade de mâche avec œuf mimosa", descEN: "Corn salad with mimosa egg", price: "11.50" },
        { name: "Nüsslisalat mit Champignons Ei Speck", descIT: "Valeriana con champignon, uovo e speck", descDE: "Nüsslisalat mit Champignons, Ei und Speck", descFR: "Mâche aux champignons, œuf et lard", descEN: "Corn salad with mushrooms, egg and bacon", price: "13.50" },
        { name: "Kürbis Cremesuppe", descIT: "Vellutata di zucca", descDE: "Kürbis-Cremesuppe", descFR: "Velouté de potiron", descEN: "Pumpkin cream soup", price: "12.50" }
      ]
    },
    {
      name: "Pasta",
      nameIT: "Pasta",
      nameDE: "Pasta",
      nameFR: "Pâtes",
      nameEN: "Pasta",
      items: [
        { name: "Tortellini di Carne alla Bolognese", descIT: "Tortellini ripieni di carne con ragù", descDE: "Tortellini gefüllt mit Fleisch und Hackfleischsauce", descFR: "Tortellinis farcis à la viande avec sauce bolognaise", descEN: "Meat-filled tortellini with bolognese sauce", price: "22.00" },
        { name: "Gnocchi alla Zucca con Pomodoro e Burrata", descIT: "Gnocchi di zucca con salsa di pomodoro e burrata", descDE: "Kürbis-Gnocchi mit Tomatenrahmsauce und Burrata", descFR: "Gnocchis au potiron avec sauce tomate et burrata", descEN: "Pumpkin gnocchi with tomato sauce and burrata", price: "26.00" },
        { name: "Risotto alla Milanese con Straccietti di Vitello", descIT: "Risotto allo zafferano con straccetti di vitello", descDE: "Safran-Risotto mit Kalbfleischstreifen", descFR: "Risotto au safran avec émincé de veau", descEN: "Saffron risotto with strips of veal", price: "28.00" },
        { name: "Paccheri con Nduja e Burrata", descIT: "Paccheri con nduja piccante e burrata", descDE: "Paccheri mit Nduja (scharfe Streichsalami) und Burrata", descFR: "Paccheri avec nduja piquante et burrata", descEN: "Paccheri with spicy nduja and burrata", price: "25.00" },
        { name: "Delizia Ricotta e Spinaci con Burrata", descIT: "Pasta ripiena con ricotta, spinaci e burrata", descDE: "Gefüllte Pasta mit Ricotta, Spinat und Burrata", descFR: "Pâtes farcies ricotta, épinards et burrata", descEN: "Filled pasta with ricotta, spinach and burrata", price: "25.00" }
      ]
    },
    {
      name: "Pizza",
      nameIT: "Pizza",
      nameDE: "Pizza",
      nameFR: "Pizza",
      nameEN: "Pizza",
      items: [
        { name: "Pizza Salsiccia Gorgonzola e Burrata", descIT: "Pizza con salsiccia, gorgonzola e burrata", descDE: "Pizza mit Salsiccia, Gorgonzola und Burrata", descFR: "Pizza avec saucisse, gorgonzola et burrata", descEN: "Pizza with sausage, gorgonzola and burrata", price: "24.00" },
        { name: "Pizza Ventricina Burrata", descIT: "Pizza con ventricina e burrata", descDE: "Pizza mit Ventricina und Burrata", descFR: "Pizza avec ventricina et burrata", descEN: "Pizza with ventricina and burrata", price: "22.00" }
      ]
    }
  ]
};
